import { GzRmScoreOverTimeWidgetWebComponent } from './component/GzRmScoreOverTimeWidgetWebComponent';

export { GzRmScoreOverTimeWidgetWebComponent };
